import styles from '../register-style.css';
import { classes } from 'component-library';
//various componets and functions brought in for use.
const { useState, useEffect } = wp.element;
/*Componet that delays activating a button to show a form, our really anything. This is use for security i.e. bots won't know to click it. Even if they do, the delay will stop many.
props:
	buttonText: 		(string) the title of the button 
	form:  				(mixed) the content to show
	time: 				(string) time of the delay in seconds, default is 3
	buttonAttr: 		(obj) the starting attributes for the button. Defaults to include classNames
	buttonAttrShow: 	(obj) the attributes for the button when the content is being shown
	divAttr: 			(obj) the attributes for div holding the form/whatever to be revealed
	divAttrShow: 		(obj) the attributes for when the div is shown
*/
export function DelayShowForms(props) {
	let { 
			buttonText, 
			form, 
			time=3,
			buttonAttr = {}, 
			buttonAttrShow = {},
			divAttr = {},
			divAttrShow = {},
		} = props,
		counterText,
		timedAction;

	const [timeLeft, setTimeLeft] = useState(time),
		[show, setShow] = useState(false);
		
	//on creation trigger the count down. On each change of state set a time to change the state to reduce the time, this will then trigger the process again until the time runs out.
	useEffect(() => {
		if (timeLeft > 0) {
			const timer = setTimeout(() => {
				setTimeLeft(timeLeft-1);
			}, 1000);
			return () => clearTimeout(timer);
		}
	});

	//if there is no time left, activate the button to show the form
	if (timeLeft <= 0) {
		timedAction = ()=>{setShow(true)};
	}

	return <>
		<button 
			{...buttonAttr} 
			{... show? buttonAttrShow:{}} 
			className={classes(
				styles.button,
				styles.buttonInactive, 
				styles.hidebuttonShow, 
				buttonAttr.className, 
				timeLeft <= 0?styles.buttonSecondaryEggplant:null,
				show?styles.hidebutton:null, 
				show?buttonAttrShow.className:null, 
			)} 
			onClick={timedAction}
		>
			{buttonText} {timeLeft > 0 ? timeLeft:null}
		</button>
		<div 
			{...divAttr} 
			{... show? divAttrShow:{}} 
			className={classes(styles.hideHolder, divAttr.className, show?styles.hideHolder+' '+styles.hideHolderShow:null, divAttrShow.className )} 
		>
			{show?form:null}
		</div>
	</>;
}